<template>
  <default-layout :has-sidebar="true" :sidebar-items="sidebarItems">
    <v-content fill-height mb-5>
      <v-container>
        <!-- header -->
        <slot name="header">
          <!-- alert -->
          <snackbar ref="alert" class="mb-5"></snackbar>
          <!--/alert-->
        </slot>
        <!--/header -->

        <!--table -->
        <v-layout row wrap>
          <v-divider></v-divider>
          <v-flex xs12>
            <v-data-table
              :headers="tableHeaders"
              :items="tableItems"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td
                  v-for="header in tableHeaders.slice(0, -2)"
                  :key="header.value"
                  :class="
                    header.value == 'isAdmin' ? 'justify-center layout' : ''
                  "
                >
                  <v-switch
                    v-model="props.item[header.value]"
                    v-if="header.value == 'isAdmin' && currentUserIsAdmin"
                    @change="editItem(props.item)"
                    :disabled="isCurrentUser(props.item) || isAdmin(props.item)"
                  ></v-switch>
                  <span v-else>{{ props.item[header.value] }}</span>
                </td>
                <td>
                  {{
                    timestampToDate(props.item.created_on)
                      | moment("ddd, MMMM Do YYYY")
                  }}
                </td>
                <td class="justify-center layout px-0">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(props.item)"
                    v-if="currentUserIsAdmin && edittable"
                    >edit</v-icon
                  >
                  <v-icon
                    small
                    @click="deleteItem(props.item)"
                    :disabled="
                      !currentUserIsAdmin ||
                        isCurrentUser(props.item) ||
                        isAdmin(props.item)
                    "
                    >delete</v-icon
                  >
                </td>
              </template>
              <v-alert
                v-slot:no-results
                :value="true"
                color="error"
                icon="warning"
                >Your search for "{{ search }}" found no results.</v-alert
              >
            </v-data-table>
          </v-flex>
        </v-layout>
        <!--/table-->
      </v-container>
    </v-content>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/layouts/Default.vue";
import Snackbar from "@/components/Snackbar.vue";
import { timestampToDate } from "@/plugins/firebase";

export default {
  props: {
    tableItems: {
      type: Array,
      default: () => {}
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    deleteItem: {
      type: Function,
      required: true
    },
    editItem: {
      type: Function,
      required: true
    },
    search: {
      type: String
    },
    edittable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DefaultLayout,
    Snackbar
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  data() {
    return {
      windowWidth: 0,
      sidebarItems: [
        { title: "Departments", icon: "apps", to: "departments" },
        { title: "Categories", icon: "category", to: "categories" },
        { title: "Users", icon: "people", to: "users" }
      ]
    };
  },
  methods: {
    timestampToDate: timestampToDate,
    handleWindowResize() {
      this.windowWidth = window.innerWidth;
    },
    customAlert(type, message) {
      this.$refs.alert.open(type, message);
    },
    isCurrentUser(item) {
      return item.id == this.$store.state.currentUser.id;
    },
    isAdmin(user) {
      return user.isAdmin;
    }
  },
  computed: {
    currentUserIsAdmin() {
      return this.$store.state.currentUser.isAdmin;
    }
  }
};
</script>
